import axios from 'axios';
import {SinglePageApplication} from '../../types/project/Application';
import {Response} from '../../types/response/Response';

export const SPA_UPDATE_URL = '/studio/application/spa/update';

export async function updateSinglePageApplication(args: [string, SinglePageApplication]) {
  const {data} = await axios.post<Response<SinglePageApplication>>(args[0], args[1]);
  return data.body;
}
